import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
@Component({
  selector: 'app-facilities',
  templateUrl: './facilities.component.html',
  styleUrls: ['./facilities.component.scss']
})
export class FacilitiesComponent implements OnInit {
  facility:{imgUrl:string,title:string,description:string,link:string}[]=[
    {
      imgUrl:'/assets/img/facilities/campus/1.jpg',
      title:'Campus',
      description:'The campus has been modeled to facilitate the finest educational services and enhance all-round development of children.',
      link:'#'
    },
    {
      imgUrl:'/assets/img/facilities/music/1.jpg',
      title:'Music and Art',
      description:'Music can change the world because it can change people. Music is God\'s gift to man, the only art of Heaven given to earth, the only art of earth we take to Heaven.',
      link:'/campus/music'
    },
    {
      imgUrl:'/assets/img/facilities/labs/1.jpg',
      title:'Laboratories',
      description:'The school has well equipped labs with the most sophisticated equipments where students have firsthand experience at performing different experiments which helps in developing a scientific approach in them.',
      link:'/campus/labs'
    },
    {
      imgUrl:'/assets/img/facilities/transport/1.jpg',
      title:'Transport',
      description:'Our well equipped and comfortable school buses reach every corner and out-skirts of the city.',
      link:'/campus/transport'
    },
    {
      imgUrl:'/assets/img/facilities/library/1.jpg',
      title:'Library',
      description:'Our library have an open shelf system to allow the students an easy access to the books, journals, magazines, newspapers, and different types of books.',
      link:'/admission/library'
    },
  ];

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 300,
    navText: ['<', '>'],
    autoplay:true,
    autoplayHoverPause:true,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
    nav: true
  }
  constructor() { }

  ngOnInit(): void {
  }

}
